// assets
import { TransactionOutlined } from '@ant-design/icons';

// icons
const icons = { TransactionOutlined };

// ==============================|| MENU ITEMS - RECAUDO ||============================== //

const recaudo = {
  id: 'group-recaudo',
  title: 'Recaudo',
  type: 'group',
  children: [
    { id: 'recaudo', title: 'Recaudo', type: 'item', url: '/recaudo', icon: icons.TransactionOutlined, permission: 'recaudo.read' }
  ]
};

export default recaudo;
